export default (theme) => ({
  root: {
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  tableWrapper: {
    overflowX: 'auto',
    height: '100%',
    position: 'relative',
  },
  listWrapper: {
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    position: 'absolute',
  },
  grow: {
    flex: 1,
    marginTop: 24,
  },
  tableRow: {
    '&:nth-child(odd)': {
      backgroundColor: '#f9f9f9',
    },
  },
  gridContainerButton: {
    marginBottom: 24,
  },
  iconAdd: {
    marginRight: 8,
  },
  buttonAdd: {
    minWidth: 259,
    minHeight: 40,
  },
  filterIcon: {
    marginRight: theme.spacing(1),
  },
  filterWropper: {
    display: 'flex',
  },
})
